export default "__VITE_ASSET__j59zC82f__"